export const BarcodeScannerIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M.833 2.5h4.229v1.75H2.583v2.479H.833Zm14.105 0h4.229v4.229h-1.75V4.25h-2.479Zm2.479 13.25v-2.479h1.75V17.5h-4.229v-1.75ZM2.583 13.271v2.479h2.479v1.75H.833v-4.229Zm3.292-8.25h.833v9.958h-.833Zm-2.521 0h1.667v9.958H3.354Zm5 0H10v9.958H8.354Zm5.771 0h.896v9.958h-.896Zm1.625 0h.896v9.958h-.896Zm-4.917 0h2.479v9.958h-2.479Z" />
    </svg>
  )
}

export default BarcodeScannerIcon
